<template>
  <div>
    <n-tabs type="card" class="mt-8 page-tab" v-model:value="status">
      <n-tab-pane
        v-for="(item, index) in statusList"
        :key="index"
        :name="item.status"
        :tab="$t(item.name)"
      >
        <div class="grid grid-cols-12 gap-6 mt-5">
          <div
            class="
              intro-y
              col-span-12
              flex flex-wrap
              sm:flex-nowrap
              items-center
              w-full
              mt-2
            "
          >
            <div
              class="w-full mt-3 sm:mt-0 sm:ml-auto md:ml-0 flex items-center"
            >
              <div class="w-56 relative text-gray-700 dark:text-gray-300">
                <input
                  type="text"
                  class="form-control w-56 box pr-10 placeholder-theme-13"
                  placeholder="Qidiruv"
                  v-model="search"
                />
                <SearchIcon
                  class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
                />
              </div>
              <div v-if="roles.includes(role?.code)" class="flex-grow mx-4">
                <c-select-naive
                  class="w-full"
                  :label="$localeKey('name')"
                  :options="regions"
                  v-model:value="region"
                />
              </div>
              <div
                class="
                  hidden
                  flex-grow
                  text-center
                  md:block
                  mx-auto
                  text-gray-600
                "
              >
                {{ total }} dan {{ list.length }} ta ko'rsatilmoqda
              </div>
              <select v-model="limit" class="w-20 form-select box ml-4">
                <option v-for="item in limitOpt" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>

            <button
              v-if="status == 'ACCEPTED'"
              :disabled="!selectedItems.length"
              :class="{ 'opacity-40': !selectedItems.length }"
              @click="interviewConfirmShow = true"
              class="btn btn-primary shadow-md mr-2"
            >
              {{ $t("interview.call") }}
            </button>
          </div>
          <!-- BEGIN: Data List -->
          <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <app-loading :show="loading">
              <table class="table table-report -mt-2">
                <thead>
                  <tr>
                    <th class="w-16" v-if="status == 'ACCEPTED'">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :checked="$_.isEqual(selectedItems, list)"
                        @change="
                          !$_.isEqual(selectedItems, list)
                            ? (selectedItems = [...list])
                            : (selectedItems = [])
                        "
                      />
                    </th>
                    <th class="w-4 text-center">#</th>
                    <th class="whitespace-nowrap">
                      {{ $t("field.fio") }}
                    </th>
                    <th class="text-center">{{ $t("field.sendDate") }}</th>
                    <th class="text-center">
                      {{ $t("typeOfApplication") }}
                    </th>
                    <th class="text-center whitespace-nowrap">
                      {{ $t("field.phone") }}
                    </th>
                    <th class="whitespace-nowrap text-center">
                      {{ $t("status.title") }}
                    </th>
                    <th class="text-center whitespace-nowrap">
                      {{ $t("actions.title") }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="list.length">
                  <tr
                    v-for="(item, index) in list"
                    :key="index"
                    class="intro-x"
                  >
                    <td class="w-16" v-if="status == 'ACCEPTED'">
                      <input
                        :value="item"
                        v-model="selectedItems"
                        class="form-check-input"
                        type="checkbox"
                      />
                    </td>
                    <td class="w-4 text-center">
                      {{ $paginate(index, page, limit) }}
                    </td>
                    <td
                      class="font-semibold cursor-pointer"
                      @click="
                        selectedItem = item;
                        getInfoCandidate(item);
                      "
                    >
                      {{ item.candidateFullName }}
                    </td>
                    <td class="text-center">{{ item.date }}</td>
                    <td class="text-center">
                      {{
                        item?.candidateDocumentType?.code ===
                          APPLICATION_TYPES.QUALIFICATION_EXAM ||
                        !item?.candidateDocumentType?.code
                          ? $t("qualificationExam")
                          : $t("oath")
                      }}
                    </td>
                    <td class="w-40">
                      {{ item.candidateMobilePhone }}
                    </td>
                    <td>
                      <div
                        class="flex items-center justify-center"
                        :class="{
                          'text-theme-9': item.status == 'SEND',
                          'text-theme-6': item.status == 'CANCELLED',
                          'text-theme-3': item.status == 'ACCEPTED'
                        }"
                      >
                        <CheckSquareIcon
                          v-if="item.status == 'SEND'"
                          class="w-4 h-4 mr-2"
                        />
                        <XSquareIcon
                          v-else-if="item.status == 'CANCELLED'"
                          class="w-4 h-4 mr-2"
                        />
                        <CheckSquareIcon v-else class="w-4 h-4 mr-2" />
                        {{ $t(`status.${item.status}`) }}
                      </div>
                    </td>
                    <td class="table-report__action w-56">
                      <div class="flex justify-center items-center">
                        <a
                          class="flex items-center ml-3 btn btn-primary"
                          href="javascript:;"
                          @click="
                            selectedItem = item;
                            getInfoCandidate(item);
                          "
                        >
                          <UserIcon class="w-5 h-5" />
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <not-found v-else colspan="9"></not-found>
              </table>
            </app-loading>
          </div>
          <!-- END: Data List -->
          <!-- BEGIN: Pagination -->
          <n-pagination
            v-model:page="page"
            :page-count="Math.ceil(total / limit)"
          />
          <!-- END: Pagination -->
        </div>
      </n-tab-pane>
    </n-tabs>
    <!-- cancel confirm -->
    <n-modal v-model:show="cancelShow">
      <n-card style="width: 600px">
        <template #header>
          <div>{{ $t("rejectionReason") }}</div>
        </template>
        <n-input
          v-model:value="cancelReason"
          type="textarea"
          placeholder="Sababi"
        />
        <template #action>
          <div class="flex items-center justify-end">
            <n-button @click="cancelShow = false" class="mr-5">
              Bekor qilish
            </n-button>
            <n-button type="error" @click="setCancelStatus">
              Rad qilish
            </n-button>
          </div>
        </template>
      </n-card>
    </n-modal>
    <!-- END: Delete Confirmation Modal -->
    <!-- create interview -->
    <n-modal
      v-model:show="interviewShow"
      preset="dialog"
      :mask-closable="false"
      style="width: 500px"
    >
      <template #header>
        <h1 class="">{{ $t("callCandidateToConversation") }}</h1>
      </template>
      <InterviewForm
        @close="interviewShow = false"
        @success="createInterview"
      />
    </n-modal>
    <!-- confirm selected -->
    <n-modal
      v-model:show="interviewConfirmShow"
      preset="dialog"
      :mask-closable="false"
      class="large-modal"
    >
      <template #header>
        <h1 class="">{{ $t("actions.confirm") }}</h1>
      </template>
      <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="w-16">
                <input class="form-check-input" type="checkbox" disabled />
              </th>
              <th class="whitespace-nowrap">{{ $t("field.fio") }}</th>
              <th class="whitespace-nowrap text-center">
                {{ $t("status.title") }}
              </th>
              <th class="text-center whitespace-nowrap">
                {{ $t("actions.title") }}
              </th>
            </tr>
          </thead>
          <tbody v-if="list.length">
            <tr
              v-for="(item, index) in selectedItems"
              :key="index"
              class="intro-x"
            >
              <td class="w-16">
                <input
                  :value="item"
                  v-model="selectedItems"
                  class="form-check-input"
                  type="checkbox"
                />
              </td>
              <td class="font-semibold">
                {{ item.candidateFullName }}
              </td>
              <td>
                <div
                  class="flex items-center justify-center"
                  :class="{
                    'text-theme-9': item.status == 'SEND',
                    'text-theme-6': item.status == 'CANCELLED',
                    'text-theme-3': item.status == 'ACCEPTED'
                  }"
                >
                  <CheckSquareIcon
                    v-if="item.status == 'SEND'"
                    class="w-4 h-4 mr-2"
                  />
                  <XSquareIcon
                    v-if="item.status == 'CANCELLED'"
                    class="w-4 h-4 mr-2"
                  />
                  <CheckSquareIcon v-else class="w-4 h-4 mr-2" />
                  {{ $t(`status.${item.status}`) }}
                </div>
              </td>
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <a
                    class="flex items-center ml-3"
                    href="javascript:;"
                    @click="
                      sidebarShow = true;
                      selectedItem = item;
                    "
                  >
                    <EyeIcon class="w-4 h-4 m-1" />
                    {{ $t("actions.view") }}
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <not-found v-else colspan="6"></not-found>
        </table>
      </div>
      <template #action>
        <div class="flex justify-end">
          <button
            v-if="selectedItems.length"
            @click="interviewShow = true"
            class="btn btn-primary shadow-md"
          >
            {{ $t("actions.confirm") }}
          </button>
        </div>
      </template>
    </n-modal>
    <!-- Confirm -->
    <n-modal
      v-model:show="acceptShow"
      :mask-closable="false"
      preset="dialog"
      :title="$t('actions.confirm')"
      :content="$t('actions.confirm')"
      :positive-text="$t('actions.accept')"
      :negative-text="$t('actions.cancel')"
      @positive-click="setAcceptStatus"
      @negative-click="acceptShow = false"
    />
    <!-- Candidate info -->
    <!-- Candidate Info -->
    <n-modal
      v-model:show="sidebarShow"
      preset="dialog"
      class="extra-modal bg-theme-2"
    >
      <template #header>
        <div class="flex justify-end items-center w-full">
          <button
            v-if="status == 'SEND'"
            @click="acceptShow = true"
            class="btn bg-theme-10 text-sm text-white"
          >
            <CheckCircleIcon class="mr-1 w-5" />
            {{ $t("actions.accept") }}
          </button>
          <button
            v-if="status == 'SEND'"
            @click="cancelShow = true"
            class="btn btn-danger mx-5 text-sm"
          >
            <XIcon class="mr-1 w-5" />
            {{ $t("actions.reject") }}
          </button>
        </div>
      </template>
      <app-loading :show="loading" class="">
        <div class="grid grid-cols-12 gap-6">
          <div class="intro-y col-span-12 lg:col-span-4 xl:col-span-3">
            <div class="relative flex items-center p-5">
              <div class="w-24 h-24 image-fit flex-shrink-0">
                <n-image
                  v-if="candidateInfo.uploadPath"
                  class="rounded-full wrap-can-image"
                  :src="`${$baseUrl}/${candidateInfo.uploadPath}`"
                />
                <img v-else class="rounded-full" src="" alt />
              </div>
              <div class="ml-4 mr-auto">
                <div class="font-medium text-base">
                  {{ candidateInfo.lastName }} {{ candidateInfo.firstName }}
                  {{ candidateInfo.parentName }}
                </div>
                <div class="text-theme-1 text-opacity-60">
                  {{ candidateInfo.mobilePhone }}
                </div>
              </div>
            </div>
            <div
              class="box border-t border-gray-200 dark:border-dark-5"
              style="min-height: 500px"
            >
              <div class="px-4 pb-3 pt-5 ref-link">
                <button
                  class="flex items-center px-4 py-2 mt-1 one-line w-full"
                  :class="{
                    'bg-theme-1 text-white font-medium rounded-lg':
                      selectedDocumentType === DOCUMENT_TYPES.PASSPORT
                  }"
                  @click="
                    showPassportData = true;
                    selectedDocumentType = DOCUMENT_TYPES.PASSPORT;
                  "
                >
                  <div class="flex-1 truncate">
                    {{ $t("passportData") }}
                  </div>
                </button>
                <button
                  class="flex items-center px-4 py-2 mt-1 one-line w-full"
                  :class="{
                    'bg-theme-1 text-white font-medium rounded-lg':
                      selectedDocumentType === DOCUMENT_TYPES.INTERN
                  }"
                  @click="selectedDocumentType = DOCUMENT_TYPES.INTERN"
                >
                  <div class="flex-1 truncate">
                    {{ $t("intern") }}
                  </div>
                </button>
                <button
                  v-for="(file, index) in candidateInfo.file"
                  :key="index"
                  class="flex items-center px-4 py-2 mt-1 one-line w-full"
                  :class="{
                    'bg-theme-1 text-white font-medium rounded-lg':
                      file.id == currentFile.id && !showPassportData
                  }"
                  @click="
                    currentFile = { ...file };
                    showPassportData = false;
                  "
                >
                  <div class="flex-1 truncate">
                    {{ file[$localeKey("docTypeName")] }}
                  </div>
                </button>
                <button
                  v-for="(listItem, index) in candidateList"
                  :key="index"
                  class="flex items-center px-4 py-2 mt-1 one-line w-full"
                  :class="{
                    'bg-theme-1 text-white font-medium rounded-lg':
                      selectedDocumentType === listItem.type.code
                  }"
                  @click="selectedDocumentType = listItem.type.code"
                >
                  <div class="flex-1 truncate">
                    {{ listItem.type.name }}
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="col-span-12 lg:col-span-8 xl:col-span-9">
            <div
              v-if="
                filteredDocumentTypes.length &&
                  selectedDocumentType !== DOCUMENT_TYPES.POSITION_HISTORY
              "
              class="bg-white rounded shadow-sm w-full px-4"
            >
              <div v-if="filteredDocumentTypes.length" class="files-section">
                <h3 class="files-title">
                  {{ $t("documents") }}
                </h3>

                <div class="files-list">
                  <div
                    v-for="file in filteredDocumentTypes"
                    :key="file.id"
                    class="file-item"
                    @click="openFile(file)"
                  >
                    <div class="file-icon-wrapper">
                      <file-icon />
                    </div>

                    <div class="file-info-text">
                      <div class="file-name-text">{{ file.fileName }}</div>
                      <div class="file-description-text">
                        {{ file[$localeKey("docTypeName")] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-files">
                <p class="text-gray-400">
                  {{ $t("noDocument") }}
                </p>
              </div>
            </div>

            <div
              v-if="
                positionDocumentFiles.length &&
                  selectedDocumentType === DOCUMENT_TYPES.POSITION_HISTORY
              "
              class="bg-white rounded shadow-sm w-full px-4"
            >
              <div v-if="positionDocumentFiles.length" class="files-section">
                <h3 class="files-title">
                  {{ $t("documents") }}
                </h3>

                <div class="files-list">
                  <div
                    v-for="file in positionDocumentFiles"
                    :key="file.id"
                    class="file-item"
                    @click="openFile(file)"
                  >
                    <div class="file-icon-wrapper">
                      <file-icon />
                    </div>

                    <div class="file-info-text">
                      <div class="file-name-text">{{ file.fileName }}</div>
                      <div class="file-description-text">
                        {{ file[$localeKey("docTypeName")] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-files">
                <p class="text-gray-400">
                  {{ $t("noDocument") }}
                </p>
              </div>
            </div>
            <passport-table
              v-if="selectedDocumentType === DOCUMENT_TYPES.PASSPORT"
              :last-name="candidateInfo.lastName"
              :first-name="candidateInfo.firstName"
              :parent-name="candidateInfo.parentName"
              :passport-number="candidateInfo.passportNumber"
              :passport-given-date="candidateInfo.passportGivenDate"
              :passport-end-date="candidateInfo.passportEndDate"
              :inps="candidateInfo.inps"
              :candidate-nationality="candidateInfo.nationality"
              :mobile-phone="candidateInfo.mobilePhone"
              :candidate-email="candidateInfo.email"
            />
            <higher-education-record-table
              v-if="
                selectedDocumentType === DOCUMENT_TYPES.DIPLOM &&
                  typeof degreeList.response !== 'string'
              "
              v-for="education in degreeList.response"
              class="mb-4"
              :institutionName="education.institution_name"
              :eduStartingDate="education.edu_starting_date"
              :eduFinishingDate="education.edu_finishing_date"
              :institutionTypeName="education.institution_type_name"
              :diplomaTypeName="education.diploma_type_name"
              :eduFormName="education.edu_form_name"
              :diplomaSerial="education.diploma_serial"
              :diplomaNumber="education.diploma_number"
              :diplomaGivenDate="education.diploma_given_date"
              :degreeName="education.degree_name"
              :eduDurationName="education.edu_duration_name"
              :diplomaStatus="education.status_name"
            />
            <div
              v-if="
                selectedDocumentType === DOCUMENT_TYPES.DIPLOM &&
                  typeof degreeList.response === 'string'
              "
              class="w-full bg-white p-4 rounded-md"
            >
              {{ degreeList.response }}
            </div>
            <positions-record-table
              v-if="
                selectedDocumentType === DOCUMENT_TYPES.POSITION_HISTORY &&
                  typeof positionHistoryRecord.response !== 'string'
              "
              v-for="position in positionHistoryRecord.response"
              class="mb-4"
              :organizationName="position.company_name"
              :department="position.structure_name"
              :positionName="position.position_name"
              :address="position.workplace_address"
              :tin="position.company_inn"
              :orderDate="position.order_date"
              :orderNumber="position.order_number"
              :startDate="position.start_date"
              :endDate="position.end_date"
            />
            <div
              v-if="
                selectedDocumentType === DOCUMENT_TYPES.DIPLOM &&
                  typeof positionHistoryRecord.response === 'string'
              "
              class="w-full bg-white p-4 rounded-md"
            >
              {{ positionHistoryRecord.response }}
            </div>
            <criminal-record-table
              v-if="selectedDocumentType === DOCUMENT_TYPES.CRIMINAL_RECORDS"
              class="mb-4"
              :sendDate="criminalRecord.response.result.created_at"
              :renew-date="criminalRecord.response.result.updated_at"
              :comment="criminalRecord.response.result.comment"
            />
            <psychiatry-record-table
              v-if="selectedDocumentType === DOCUMENT_TYPES.PSYCHO_DISPANSER"
              class="mb-4"
              :sendDate="psychoDispanserRecord.createdDate"
              :renew-date="psychoDispanserRecord.updatedDate"
              :comment="psychoDispanserRecord.response"
            />
            <narcology-record-table
              v-if="selectedDocumentType === DOCUMENT_TYPES.NARCO_DISPANSER"
              class="mb-4"
              :sendDate="narcoDispanserRecord.createdDate"
              :renew-date="narcoDispanserRecord.updatedDate"
              :comment="narcoDispanserRecord.response"
            />
          </div>
        </div>
      </app-loading>
    </n-modal>
    <n-modal
      v-model:show="showFileModal"
      :mask-closable="true"
      class="file-preview-modal"
    >
      <n-card
        :title="currentFilePreview?.fileName"
        :bordered="false"
        size="huge"
        role="dialog"
        aria-modal="true"
        class="file-preview-card"
        closable
        @close="showFileModal = false"
      >
        <FileView v-if="currentFilePreview" :file="currentFilePreview" />
      </n-card>
    </n-modal>
  </div>
</template>

<script>
import { ref, defineComponent, onMounted, computed, watch } from "vue";
import { useRouter } from "vue-router";
import CandidateService from "@/services/candidate/Candidate.service";
import InterviewService from "@/services/interview.service";
import RegionsService from "@/services/reference/region.service";
import { TokenService } from "@/services/storage.service";
import FileView from "@/components/main/file-view.vue";
import InterviewForm from "./components/InterviewForm.vue";
import CSelectNaive from "@/components/hrm-components/CSelectNaive.vue";
import { useI18n } from "vue-i18n";
import { useLoadingBar, useMessage } from "naive-ui";
import PositionsRecordTable from "./components/PositionsRecordTable.vue";
import CriminalRecordTable from "./components/CriminalRecordTable.vue";
import HigherEducationRecordTable from "./components/HigherEducationRecordTable.vue";
import PassportTable from "./components/PassportTable.vue";
import PsychiatryRecordTable from "./components/PsychiatryRecordTable.vue";
import NarcologyRecordTable from "./components/NarcologyRecordTable.vue";
import { APPLICATION_TYPES, DOCUMENT_TYPES } from "@/utils/enum";
import { FileIcon } from "@zhuowenli/vue-feather-icons";

export default defineComponent({
  computed: {
    APPLICATION_TYPES() {
      return APPLICATION_TYPES;
    }
  },
  components: {
    FileView,
    InterviewForm,
    CSelectNaive,
    PositionsRecordTable,
    CriminalRecordTable,
    HigherEducationRecordTable,
    PassportTable,
    PsychiatryRecordTable,
    NarcologyRecordTable,
    FileIcon
  },
  setup() {
    const degreeList = ref([]);
    const files = ref([]);
    const criminalRecord = ref({});
    const narcoDispanserRecord = ref([]);
    const psychoDispanserRecord = ref([]);
    const positionHistoryRecord = ref([]);
    const { t } = useI18n();
    const message = useMessage();
    const loadingBar = useLoadingBar();
    const router = useRouter();
    const page = ref(1);
    const list = ref([]);
    const cancelShow = ref(false);
    let sidebarShow = ref(false);
    const interviewShow = ref(false);
    const interviewConfirmShow = ref(false);
    const form = ref({
      date: Date.now(),
      phone: ""
    });
    let candidateList = ref([]);
    let regions = ref([]);
    let region = ref("");
    let total = ref(0);
    let loading = ref(false);
    let limitOpt = [10, 20, 50, 100];
    let limit = ref(20);
    let search = ref("");
    let status = ref("SEND");
    let role = ref("");
    let roles = ref(["ROLE_ADMIN", "ROLE_MAIN_ADMIN"]);
    let selectedDocumentType = ref(DOCUMENT_TYPES.PASSPORT);

    const showFileModal = ref(false);
    const currentFilePreview = ref(null);

    function openFile(file) {
      currentFilePreview.value = file;
      showFileModal.value = true;
    }

    let statuss = ref(["SEND", "SEEN"]);
    watch(status, val => {
      if (val == "SEND") statuss.value = ["SEND", "SEEN"];
      else statuss.value = val;
    });

    let paramsComp = computed(() => {
      return {
        search: search.value,
        status: statuss.value,
        regionId: region.value?.id || "",
        params: {
          page: page.value - 1,
          limit: limit.value
        }
      };
    });

    async function getList() {
      let payload = { ...paramsComp.value };
      payload.regionId = [payload.regionId];
      try {
        loading.value = true;
        let res = await CandidateService.getList(payload);
        list.value = res.data.list;
        total.value = res.data.total;
      } catch {
        list.value = [];
        total.value = 0;
      } finally {
        loading.value = false;
      }
    }

    async function getRegions() {
      let res = await RegionsService.getList();
      regions.value = res.data?.[0]?.children;
    }

    let statusList = ref([
      {
        status: "SEND",
        name: "arizaSent"
      },
      {
        status: "ACCEPTED",
        name: "arizaAccepted"
      },
      {
        status: "CANCELLED",
        name: "arizaCancelled"
      }
    ]);
    let selectedItem = ref({});
    let cancelReason = ref("");
    onMounted(() => {
      role.value = TokenService.getUserRoles();
      getList(paramsComp.value);
      getRegions();
    });
    watch(paramsComp, val => {
      getList();
    });

    async function setCancelStatus() {
      try {
        loadingBar.start();
        await CandidateService.cancel({
          comment: cancelReason.value,
          id: selectedItem.value.id
        });
        message.info(t("success.saved"));
        cancelShow.value = false;
        cancelReason.value = "";
        sidebarShow.value = false;
        await getList();
      } finally {
        loadingBar.finish();
      }
    }

    // accept
    let acceptShow = ref(false);

    async function setAcceptStatus() {
      try {
        loadingBar.start();
        await CandidateService.accept({
          id: selectedItem.value.id
        });
        acceptShow.value = false;
        sidebarShow.value = false;
        message.success(t("success.saved"));
        await getList();
      } finally {
        loadingBar.finish();
      }
    }

    // Select and send
    let selectedItems = ref([]);

    async function createInterview(e) {
      let payload = {
        ...e,
        candidateIds: selectedItems.value.map(el => el.id)
      };
      try {
        loadingBar.start();
        await InterviewService.create(payload);
        message.success(t("success.saved"));
        router.push("/interview");
      } finally {
        loadingBar.finish();
      }
    }

    // Show candidate files
    let candidateInfo = ref({});
    let currentFile = ref({});
    let showPassportData = ref(true);
    let filteredDocumentTypes = ref([]);
    let positionDocumentFiles = ref([]);

    async function getInfoCandidate(item) {
      sidebarShow.value = true;
      showPassportData.value = true;
      try {
        loading.value = true;
        let res = await CandidateService.getCandidateDocById(item.id);
        candidateList.value = res.data.list;
        candidateInfo.value = res.data.candidateDto || {};
        criminalRecord.value = res.data.list.find(
          item => item.type.code === DOCUMENT_TYPES.CRIMINAL_RECORDS
        );
        degreeList.value = res.data.list.find(
          item => item.type.code === DOCUMENT_TYPES.DIPLOM
        );
        narcoDispanserRecord.value = res.data.list.find(
          item => item.type.code === DOCUMENT_TYPES.NARCO_DISPANSER
        );
        psychoDispanserRecord.value = res.data.list.find(
          item => item.type.code === DOCUMENT_TYPES.PSYCHO_DISPANSER
        );
        positionHistoryRecord.value = res.data.list.find(
          item => item.type.code === DOCUMENT_TYPES.POSITION_HISTORY
        );

        files.value = res.data.files;

        res.data.currentFile.value = candidateInfo.value.uploadPath || {};
      } finally {
        loading.value = false;
      }
    }

    watch(selectedDocumentType, value => {
      filteredDocumentTypes.value = Array.isArray(files.value)
        ? files.value.filter(item => {
            return item.code.code === selectedDocumentType.value;
          })
        : [];

      if (value === DOCUMENT_TYPES.POSITION_HISTORY) {
        positionDocumentFiles.value = Array.isArray(files.value)
          ? files.value.filter(item => {
              return item.code.code === DOCUMENT_TYPES.POSITION;
            })
          : [];
      }
    });

    return {
      candidateInfo,
      currentFile,
      getInfoCandidate,
      showPassportData,
      candidateList,
      interviewShow,
      page,
      cancelShow,
      form,
      list,
      total,
      limit,
      limitOpt,
      loading,
      search,
      sidebarShow,
      interviewConfirmShow,
      statusList,
      status,
      cancelReason,
      selectedItem,
      setCancelStatus,
      acceptShow,
      setAcceptStatus,
      selectedItems,
      createInterview,
      regions,
      region,
      roles,
      role,
      selectedDocumentType,
      degreeList,
      criminalRecord,
      narcoDispanserRecord,
      psychoDispanserRecord,
      positionHistoryRecord,
      DOCUMENT_TYPES,
      files,
      filteredDocumentTypes,
      showFileModal,
      openFile,
      currentFilePreview,
      positionDocumentFiles
    };
  }
});
</script>
<style lang="scss">
.wrap-can-image {
  img {
    object-fit: contain !important;
  }
}

.page-tab .n-tabs-tab__label {
  @apply text-xl font-roboto;
}

.drawer-tab {
  .n-tabs-tab {
    span {
      max-width: 250px !important;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
// Files section
.files-section {
  padding-top: 24px;
  padding-bottom: 24px;
}

.files-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #333639;
  margin-bottom: 16px;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid rgba(104, 101, 118, 0.15);
  border-radius: 8px;
  background: #fff;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: #3361ff;
    background: rgba(51, 97, 255, 0.03);
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(51, 97, 255, 0.08);
  }
}

.file-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(104, 101, 118, 0.05);
  border-radius: 6px;
  flex-shrink: 0;
}

.file-info-text {
  flex: 1;
  min-width: 0;
}

.file-name-text {
  font-size: 14px;
  font-weight: 600;
  color: #333639;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.file-description-text {
  font-size: 12px;
  color: rgba(104, 101, 118, 0.7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-files {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  margin-top: 24px;
  text-align: center;
  color: rgba(104, 101, 118, 0.5);
}
</style>

<style>
/* Modal global styles */
.file-preview-modal .n-card {
  max-width: 95vw !important;
  width: 1200px !important;
  max-height: 95vh !important;
}

.file-preview-card {
  overflow: auto;
}

.file-preview-card .n-card__content {
  padding: 0 !important;
}
</style>
